import {useAuth} from '../../auth'
import {QHSE_PERMS} from './permissions'

type MonthEndFeature = 'main-engine' | 'machinery-status' | 'module1-report'

const FEATURE_PERMISSIONS: Record<
  MonthEndFeature,
  {read: string; create: string; update: string; delete: string}
> = {
  'main-engine': {
    read: QHSE_PERMS.MONTH_END_ME_READ,
    create: QHSE_PERMS.MONTH_END_ME_CREATE,
    update: QHSE_PERMS.MONTH_END_ME_UPDATE,
    delete: QHSE_PERMS.MONTH_END_ME_DELETE,
  },
  'machinery-status': {
    read: QHSE_PERMS.MONTH_END_MACHINERY_READ,
    create: QHSE_PERMS.MONTH_END_MACHINERY_CREATE,
    update: QHSE_PERMS.MONTH_END_MACHINERY_UPDATE,
    delete: QHSE_PERMS.MONTH_END_MACHINERY_DELETE,
  },
  'module1-report': {
    read: QHSE_PERMS.MONTH_END_REPORT_READ,
    create: QHSE_PERMS.MONTH_END_REPORT_CREATE,
    update: QHSE_PERMS.MONTH_END_REPORT_UPDATE,
    delete: QHSE_PERMS.MONTH_END_REPORT_DELETE,
  },
}

export const useMonthEndFeatureAccess = (feature: MonthEndFeature) => {
  const {can, currentUser} = useAuth()
  const perms = FEATURE_PERMISSIONS[feature]

  const assignedVesselId = currentUser?.vessel?.id ? Number(currentUser.vessel.id) : null
  const assignedCompanyGroupId =
    currentUser?.companyGroupAdminId != null
      ? Number(currentUser.companyGroupAdminId)
      : currentUser?.companyGroupAdmin?.id != null
        ? Number(currentUser.companyGroupAdmin.id)
        : null
  const assignedCompanyAdminId =
    currentUser?.companyAdminId != null
      ? Number(currentUser.companyAdminId)
      : currentUser?.companyAdmin?.id != null
        ? Number(currentUser.companyAdmin.id)
        : null

  const hasAssignedVessel = assignedVesselId != null
  const hasAssignedOfficeScope = assignedCompanyGroupId != null || assignedCompanyAdminId != null
  const isGlobalScope = !hasAssignedVessel && !hasAssignedOfficeScope
  const isOfficeUser = !hasAssignedVessel

  const canRead = can(perms.read)
  const canCreate = can(perms.create)
  const canUpdate = can(perms.update)
  const canDelete = can(perms.delete)

  return {
    canRead,
    canCreate,
    canUpdate,
    canDelete,
    hasAssignedVessel,
    assignedVesselId,
    assignedCompanyGroupId,
    assignedCompanyAdminId,
    hasAssignedOfficeScope,
    isGlobalScope,
    isOfficeUser,
  }
}
